import { useState, useCallback } from 'react';
import { HexColorPicker } from 'react-colorful';
import './App.css';

const PRESET_COLORS = [
  '#ff0000', '#ff4500', '#ff8c00', '#ffd700',
  '#32cd32', '#00ced1', '#1e90ff', '#4169e1',
  '#8a2be2', '#ff1493', '#ff69b4', '#ffffff',
  '#000000', '#808080', '#a0522d', '#f5f5dc',
];

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null;
  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  };
}

function App() {
  const [color, setColor] = useState('#1e90ff');
  const [hexInput, setHexInput] = useState('#1e90ff');

  const handleColorChange = useCallback((newColor) => {
    setColor(newColor);
    setHexInput(newColor);
  }, []);

  const handleHexInput = (e) => {
    const value = e.target.value;
    setHexInput(value);
    if (/^#[0-9a-fA-F]{6}$/.test(value)) {
      setColor(value);
    }
  };

  const rgb = hexToRgb(color);

  return (
    <div className="App">
      <div className="picker-card">
        <h1 className="title">Color Picker</h1>

        <HexColorPicker color={color} onChange={handleColorChange} />

        <div className="color-preview" style={{ backgroundColor: color }}>
          <span className="preview-label" style={{
            color: rgb && (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) > 150
              ? '#000' : '#fff'
          }}>
            {color.toUpperCase()}
          </span>
        </div>

        <div className="color-info">
          <div className="hex-input-group">
            <label htmlFor="hex-input">HEX</label>
            <input
              id="hex-input"
              type="text"
              value={hexInput}
              onChange={handleHexInput}
              maxLength={7}
              spellCheck={false}
            />
          </div>
          {rgb && (
            <div className="rgb-display">
              <span>R: {rgb.r}</span>
              <span>G: {rgb.g}</span>
              <span>B: {rgb.b}</span>
            </div>
          )}
        </div>

        <div className="presets">
          <p className="presets-label">Presets</p>
          <div className="preset-grid">
            {PRESET_COLORS.map((presetColor) => (
              <button
                key={presetColor}
                className={`preset-swatch${color === presetColor ? ' active' : ''}`}
                style={{ backgroundColor: presetColor }}
                onClick={() => handleColorChange(presetColor)}
                aria-label={`Select color ${presetColor}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
